"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
const PhoneHelper = () => ({ parsePhoneNumber: libphonenumber_js_1.default });
exports.default = PhoneHelper;
